(function () {
  const STORAGE_KEY = "yasmina_utm";
  const UTM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
  ];

  function readStored() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (err) {
      return {};
    }
  }

  function writeStored(params) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params));
    } catch (err) {}
  }

  function readFromUrl() {
    const search = new URL(window.location.href).searchParams;
    const found = {};
    UTM_KEYS.forEach((key) => {
      const value = search.get(key);
      if (value) found[key] = value;
    });
    return found;
  }

  function capture() {
    const stored = readStored();
    const fromUrl = readFromUrl();
    if (!Object.keys(fromUrl).length) return stored;
    const merged = Object.assign(stored, fromUrl);
    writeStored(merged);
    return merged;
  }

  const captured = capture();

  // Colour of the swatch selected on the page, slugified for the UTM value.
  function selectedColor() {
    const active = document.querySelector(
      "[data-variant-id].is-active:not([name])",
    );
    if (!active) return "";
    const label =
      active.getAttribute("data-variant-color") ||
      (active.querySelector(".color__item-text") || {}).textContent ||
      "";
    return label.trim().toLowerCase().replace(/\s+/g, "-");
  }

  function resolve() {
    const config = window.storeConfig || {};
    const resolved = {};
    UTM_KEYS.forEach((key) => {
      if (captured[key]) resolved[key] = captured[key];
    });
    resolved.utm_medium = config.utmMedium || "product_page_old_shopify";
    resolved.utm_content = config.utmContent || "general";
    if (!resolved.utm_source) resolved.utm_source = "old_shopify";

    // Only device pages carry a colour: home and /products stay as they are.
    if (resolved.utm_content !== "general") {
      const color = selectedColor();
      if (color) resolved.utm_content += "_" + color;
    }
    return resolved;
  }

  function decorate(button) {
    const url = new URL(
      button.getAttribute("href") || "/checkout",
      window.location.origin,
    );
    const resolved = resolve();
    Object.keys(resolved).forEach((key) => {
      url.searchParams.set(key, resolved[key]);
    });
    button.setAttribute("href", url.pathname + url.search);
    button.removeAttribute("target");
    button.removeAttribute("rel");
  }

  document.addEventListener(
    "click",
    (event) => {
      const button = event.target.closest("[data-checkout]");
      if (button) decorate(button);
    },
    true,
  );
})();
